var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, } from "react";
import { SkipToMainContent } from "@react-md/link";
import { LayoutAppBar } from "./LayoutAppBar";
import { LayoutMain } from "./LayoutMain";
import { LayoutNavigation } from "./LayoutNavigation";
import { useLayoutConfig } from "./LayoutProvider";
import { MiniLayoutWrapper } from "./MiniLayoutWrapper";
import { isMiniLayout } from "./utils";
/**
 * The only purpose of this component is to render the children and different
 * parts of the `Layout` depending on the current layout that is active. Since
 * the `Layout` component defines the provider itself, this has to be a child
 * component to get the resolved `layout` type.
 *
 * @remarks \@since 2.7.0
 * @internal
 */
export function LayoutChildren(_a) {
    var _b = _a.id, id = _b === void 0 ? "layout" : _b, propAppBar = _a.appBar, appBarProps = _a.appBarProps, customTitle = _a.customTitle, title = _a.title, titleProps = _a.titleProps, navToggle = _a.navToggle, navToggleProps = _a.navToggleProps, _c = _a.navAfterAppBar, navAfterAppBar = _c === void 0 ? false : _c, propNav = _a.nav, miniNav = _a.miniNav, miniNavItems = _a.miniNavItems, miniWrapperProps = _a.miniWrapperProps, navHeader = _a.navHeader, navHeaderProps = _a.navHeaderProps, navHeaderTitle = _a.navHeaderTitle, navHeaderTitleProps = _a.navHeaderTitleProps, closeNav = _a.closeNav, closeNavProps = _a.closeNavProps, treeProps = _a.treeProps, navProps = _a.navProps, skipProps = _a.skipProps, mainProps = _a.mainProps, children = _a.children;
    var mainId = (mainProps === null || mainProps === void 0 ? void 0 : mainProps.id) || "".concat(id, "-main");
    var _d = useLayoutConfig(), layout = _d.layout, visible = _d.visible, fixedAppBar = _d.fixedAppBar;
    var mini = isMiniLayout(layout);
    var _e = __read(useState(visible), 2), miniHidden = _e[0], setMiniHidden = _e[1];
    // when the layout changes, the hidden state for the mini drawer must also be
    // updated
    useEffect(function () {
        setMiniHidden(visible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [layout]);
    var appBar = propAppBar;
    if (typeof appBar === "undefined") {
        appBar = (_jsx(LayoutAppBar, __assign({}, appBarProps, { customTitle: customTitle, title: title, titleProps: titleProps, navToggle: navToggle, navToggleProps: navToggleProps }), void 0));
    }
    var nav = propNav;
    if (typeof nav === "undefined") {
        nav = (_jsx(LayoutNavigation, __assign({ header: navHeader, headerProps: navHeaderProps, headerTitle: navHeaderTitle, headerTitleProps: navHeaderTitleProps, closeNav: closeNav, closeNavProps: closeNavProps, treeProps: treeProps }, navProps, { onEntered: function (appearing) {
                var _a;
                (_a = navProps === null || navProps === void 0 ? void 0 : navProps.onEntered) === null || _a === void 0 ? void 0 : _a.call(navProps, appearing);
                setMiniHidden(true);
            }, onExit: function () {
                var _a;
                (_a = navProps === null || navProps === void 0 ? void 0 : navProps.onExit) === null || _a === void 0 ? void 0 : _a.call(navProps);
                setMiniHidden(false);
            } }), void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(SkipToMainContent, __assign({}, skipProps, { mainId: mainId }), void 0), navAfterAppBar && appBar, nav, !navAfterAppBar && appBar, _jsx(MiniLayoutWrapper, __assign({ mini: mini, miniNav: miniNav, miniHidden: miniHidden, containerProps: miniWrapperProps, miniNavItems: miniNavItems, treeProps: treeProps, header: navHeader, headerProps: navHeaderProps, headerTitle: navHeaderTitle, headerTitleProps: navHeaderTitleProps, closeNav: closeNav, closeNavProps: closeNavProps }, { children: _jsx(LayoutMain, __assign({ headerOffset: fixedAppBar, mini: mini, miniHidden: miniHidden }, mainProps, { id: mainId }, { children: children }), void 0) }), void 0)] }, void 0));
}
//# sourceMappingURL=LayoutChildren.js.map